module.exports = __webpack_public_path__ + "img/img61.57d325d9.png";